<template>
  <div class="t-container">
    <div class="search-con">
      <Select v-model="selectTemp" style="width:150px;" placeholder="请选择模板">
        <Option v-for="item in showDate.model" :key="item.id" :value="item.path">{{item.name}}</Option>
      </Select>
      <span v-if="showDate.change == 'change'">
        <Select v-model="selectYear" style="width:150px;" placeholder="请选择打印期间">
          <Option v-for="item in showDate.printlimit" :key="item" :value="item">{{item}}年</Option>
        </Select>
      </span>
      <span v-else>
        打印期限{{showDate.printlimit}}年
      </span>
      <Button @click="prientLine()" class="search-btn" type="primary">打印</Button>
      <Button @click="saveImg()" class="search-btn" type="primary">保存图片</Button>
    </div>
    <div ref="template" class="template">
      <m1 :showDate="showDate" v-if="showIndex == 'm1'" :selectYear="selectYear"></m1>
      <m2 :showDate="showDate" v-if="showIndex == 'm2'" :selectYear="selectYear"></m2>
      <m3 :showDate="showDate" v-if="showIndex == 'm3'" :selectYear="selectYear"></m3>
      <s1 :showDate="showDate" v-if="showIndex == 's1'" :selectYear="selectYear"></s1>
      <s2 :showDate="showDate" v-if="showIndex == 's2'" :selectYear="selectYear"></s2>
      <s3 :showDate="showDate" v-if="showIndex == 's3'" :selectYear="selectYear"></s3>
      <svip :showDate="showDate" v-if="showIndex == 'svip'" :selectYear="selectYear"></svip>
      <ssvip :showDate="showDate" v-if="showIndex == 'ssvip'" :selectYear="selectYear"></ssvip>
      <md1 :showDate="showDate" v-if="showIndex == 'md1'" :selectYear="selectYear"></md1>
      <md2 :showDate="showDate" v-if="showIndex == 'md2'" :selectYear="selectYear"></md2>
      <s4 :showDate="showDate" v-if="showIndex == 's4'" :selectYear="selectYear"></s4>
      <luntai1 :showDate="showDate" v-if="showIndex == 'luntai1'" :selectYear="selectYear"></luntai1>
      <s5 :showDate="showDate" v-if="showIndex == 's5'" :selectYear="selectYear"></s5>
      <s6 :showDate="showDate" v-if="showIndex == 's6'" :selectYear="selectYear"></s6>
      <s7 :showDate="showDate" v-if="showIndex == 's7'" :selectYear="selectYear"></s7>
      <s8 :showDate="showDate" v-if="showIndex == 's8'" :selectYear="selectYear"></s8>
      <s9 :showDate="showDate" v-if="showIndex == 's9'" :selectYear="selectYear"></s9>
      <w1 :showDate="showDate" v-if="showIndex == 'w1'" :selectYear="selectYear"></w1>
      <w2 :showDate="showDate" v-if="showIndex == 'w2'" :selectYear="selectYear"></w2>
      <s10 :showDate="showDate" v-if="showIndex == 's10'" :selectYear="selectYear"></s10>
      <s11 :showDate="showDate" v-if="showIndex == 's11'" :selectYear="selectYear"></s11>
       <s12 :showDate="showDate" v-if="showIndex == 's12'" :selectYear="selectYear"></s12>
       <s13 :showDate="showDate" v-if="showIndex == 's13'" :selectYear="selectYear"></s13>
       <s14 :showDate="showDate" v-if="showIndex == 's14'" :selectYear="selectYear"></s14>
       <s15 :showDate="showDate" v-if="showIndex == 's15'" :selectYear="selectYear"></s15>
    </div>
  </div>
</template>

<script>
import '@/components/scss/views/demoTem.scss'
import html2canvas from 'html2canvas'
import m1 from "./m1"
import m2 from "./m2"
import m3 from "./m3"
import s1 from "./s1"
import s2 from "./s2"
import s3 from "./s3"
import svip from "./svip"
import ssvip from "./ssvip"
import md1 from "./md1"
import md2 from "./md2"
import s4 from "./s4"
import luntai1 from "./luntai1"
import s5 from "./s5"
import s6 from "./s6"
import s7 from "./s7"
import s8 from "./s8"
import s9 from "./s9"
import w1 from "./w1"
import w2 from "./w2"
import s10 from "./s10"
import s11 from "./s11"
import s12 from "./s12"
import s13 from "./s13"
import s14 from "./s14"
import s15 from "./s15"
export default {
  name:'TemplateDetail',
  data () {
    return {
      showIndex:0,
      selectTemp: '',
      selectYear: '',
      showDate: {
        change:'',
        printlimit: '',
        model:'',
        saleslip: '',
      },
    }
  },
  watch: {
    selectTemp(newval, oldval) {
      this.showIndex = newval
    }
  },
  mounted () {
    this.getPrintInfo(this.$route.query.id)
  },
  components: {
    "m1":m1,
    "m2":m2,
    "m3":m3,
    "s1":s1,
    "s2":s2,
    "s3":s3,
    "svip":svip,
    "ssvip":ssvip,
    "md1":md1,
    "md2":md2,
    "s4":s4,
    "luntai1":luntai1,
    "s5":s5,
    "s6":s6,
    "s7":s7,
    "s8":s8,
    "s9":s9,
    "w1":w1,
    "w2":w2,
    "s10":s10,
    "s11":s11,
    "s12":s12,
    "s13":s13,
    "s14":s14,
    "s15":s15,
  },
  methods: {
    prientLine() {
      if(this.selectYear == '') {
        this.$Modal.warning({
          title: '请选择打印期限'
        });
        return
      }
      let tempdate = {
        saleslipid: this.showDate.saleslip.id,
        date: this.selectYear
      }
      this.$axios.post('/print/print',tempdate)
      .then(function (response) {
        if (response.data.success) {
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
      // this.$print(this.$refs.template)
      html2canvas(this.$refs.template).then(canvas => {
        var oldstr = document.body.innerHTML;//保存当前页面的HTML
        document.body.innerHTML = '';
        document.body.appendChild(canvas)
        window.print();
        window.location.reload();
        document.body.innerHTML = oldstr;
      });
    },
    getPrintInfo(id) {
      this.$Loading.start()
      this.$axios.get('/print/getPrintInfo/'+id)
      .then(function (response) {
        if (response.data.success) {
          this.showDate = response.data.data
          this.selectTemp = this.$route.path
          if(this.showDate.change != 'change') {
            this.selectYear = this.showDate.printlimit
          }
          if(this.showDate.model.length>0) {
            this.selectTemp = this.showDate.model[0].path
          }
          console.log(this.showDate)
          if(this.showDate.model.length==0)
          {
            this.getModel()
          }
          this.$Loading.finish()
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    getModel() {
      this.$axios.get('/model/curgroupselect')
      .then(function (response) {
        if (response.data.success) {

          this.showDate.model = response.data.data
          //console.log(this.showDate)
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    saveImg() {
      html2canvas(this.$refs.template).then(canvas => {
        this.downloadFile('保单.png', canvas.toDataURL());
      });
    },
    //下载
    downloadFile(fileName, content) {
      let aLink = document.createElement('a');
      let blob = this.base64ToBlob(content); //new Blob([content]);

      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);
      // aLink.dispatchEvent(evt);
      aLink.click()
    },
    //base64转blob
    base64ToBlob(code) {
      let parts = code.split(';base64,');
      let contentType = parts[0].split(':')[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;

      let uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {type: contentType});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/template/template.vue